<template>
  <CategoryForm />
</template>
  
<script>
  import CategoryForm from '@/components/tournament-category/CategoryForm.vue';
  export default {
    name: "TournamentCategoryCreatePage",
    components: {
      CategoryForm,
    },
  };
</script>
  